// material-ui
import { styled } from '@mui/material/styles';

// project imports
import { MenuOrientation, ThemeMode } from 'config';
import { drawerWidth } from 'store/constant';

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainContentStyled = styled('main', {
  shouldForwardProp: (prop) =>
    prop !== 'open' &&
    prop !== 'menuOrientation' &&
    prop !== 'borderRadius' &&
    prop !== 'hasDrawer' &&
    prop !== 'isNewLoginPage'
})(({ theme, open, menuOrientation, borderRadius, hasDrawer, isNewLoginPage }) => ({
  backgroundColor: !isNewLoginPage
    ? theme.palette.mode === ThemeMode.DARK
      ? theme.palette.dark[800]
      : theme.palette.grey[50]
    : theme.palette.white.paper,
  minWidth: '1%',
  width: '100%',
  minHeight: 'calc(100vh - 70px)',
  flexGrow: 1,
  paddingTop: 24,
  paddingBottom: 20,
  marginTop: 70,
  marginRight: 0,
  borderRadius: 0,

  ...(!open && hasDrawer && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter + 200
    }),
    [theme.breakpoints.up('md')]: {
      marginLeft: menuOrientation === MenuOrientation.VERTICAL ? -(drawerWidth - 72) : 20,
      width: `calc(100% - ${drawerWidth}px)`,
      marginTop: menuOrientation === MenuOrientation.HORIZONTAL ? 135 : 70
    }
  }),

  ...(open && hasDrawer && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200
    }),
    marginLeft: menuOrientation === MenuOrientation.HORIZONTAL ? 20 : 0,
    marginTop: menuOrientation === MenuOrientation.HORIZONTAL ? 135 : 70,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.up('md')]: {
      marginTop: menuOrientation === MenuOrientation.HORIZONTAL ? 135 : 70
    }
  }),
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    padding: '16 0',
    marginTop: 48,
    ...(!open && hasDrawer && {
      width: `calc(100% - ${drawerWidth}px)`
    })
  },

  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    marginRight: 0
  }
}));

export default MainContentStyled;
